import { createGlobalStyle } from 'styled-components';
import reboot from 'styled-reboot';

const rebootCss = reboot();

export default createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Raleway:wght@300;400;700;900&display=swap');

  ${rebootCss}

  :root {
    --bg-superlight: #f4f4f4;
    --bg-light: #e2e2e2;
    //--red: #de2b2f;
    //--brown: #930c0c;
    //--dark-brown: #511b1b;
    --red: #3f98d7;
    --brown: #204e1f;
    --dark-brown: #51c54e;
    --orange: #ff7400;
    --right-space: 100px;
    --row-height: 40px;
  }
  
  

  html {
    -ms-text-size-adjust: 100%;
    -webkit-text-size-adjust: 100%;
  }

  body {
    width: 100%;
    position: relative;
    left: 0;
    -webkit-overflow-scrolling: touch;
    line-height: 1.5em;
    font-family: 'Raleway', sans-serif;
    font-weight: 400;
    font-size: 16px;
  }

  .content-wrap {
    position: relative;
    width: 100%;
    max-width: 630px;
    margin:  auto;
  }

  section {
    position: relative;
    background-color: var(--bg-superlight);
    width: 100%;
    border-radius: 15px;
    padding: 15px 15px 20px 15px;
    margin: 15px 0;
  }

  h1 {
    text-transform: uppercase;
    font-weight: 800;
    padding: 15px 37px 15px 37px;
  }

  p {
    padding: 0 37px 0 37px;
  }

  .lastUpdated {
    font-size: 13px;
    font-weight: 300;
  }

  .key {
    position: relative;
    padding: 0 37px 0 37px;
    display: flex;
    width: 100%;
  }

  .keyText {
    margin-left: 30px;
    width: 100%;
  }

  .oneDoseCirc {
    position: absolute;
    width: 20px;
    height: 20px;
    background-color: var(--red);
    border-radius: 10px;
    top: 2px;
  }


  .twoDoseCirc {
    position: absolute;
    width: 20px;
    height: 20px;
    background-color: var(--dark-brown);
    border-radius: 10px;
    top: 2px;
  }

  .threeDoseCirc {
    position: absolute;
    width: 20px;
    height: 20px;
    background-color: var(--orange);
    border-radius: 10px;
    top: 2px;
  }

  .inner-section {
    position: relative;
    background-color: var(--bg-light);
    border-radius: 15px;
    filter: drop-shadow(0 4px 4px rgba(0, 0, 0, 0.4));
  }

  .table-section {
    position: relative;
    margin-top: 10px;
    background-color: var(--bg-superlight);
    border-radius: 15px;
    padding: 15px;
  }

  .row-section {
    position: relative;
    display: block;
    margin: 0 10px;
    width: calc(100% - 20px);
    padding: 10px 0;
  }

  .location {
    font-weight: 700;
  }

  .dot-plot-wrap {
    position: relative;
    width: 100%;
    background-color: var(--bg-light);
    border-radius: 10px;
    height: 20px;
    margin-top: 18px;
  }

  .dot-plot-rail {
    position: relative;
    width: calc(100% - 20px)
  }

  .first-dose-dot {
    height: 20px;
    width: 20px;
    background-color: var(--red);
    border-radius: 50%;
    position: absolute;
    opacity: 0.8;
  }

  .second-dose-dot {
    height: 20px;
    width: 20px;
    background-color: var(--dark-brown);
    border-radius: 50%;
    position: absolute;
    opacity: 0.8;
  }

  .third-dose-dot {
    height: 20px;
    width: 20px;
    background-color: var(--orange);
    border-radius: 50%;
    position: absolute;
    opacity: 0.8;
  }

  .bewtween-dots-bg {
    height: 20px;
    background-color: var(--brown);
    opacity: 0.2;
    border-radius: 10px;
    position: absolute;
  }

  .first-dose-text {
    position: absolute;
    color: var(--red);
    text-align: center;
    font-size: 14px;
    font-weight: 700;
    width: 100px;
    top: -22px;
  }

  .second-dose-text {
    position: absolute;
    color: var(--dark-brown);
    text-align: center;
    font-size: 14px;
    font-weight: 700;
    width: 100px;
    top: 17px;
  }

  .third-dose-text {
    position: absolute;
    color: var(--orange);
    text-align: right;
    font-size: 14px;
    font-weight: 700;
    width: 100px;
    top: -3px;
  }

  @media(max-width: 450px) {
    .first-dose-text {
      font-size: 11px;
    }
    .second-dose-text { 
      font-size: 11px;
    }
    .third-dose-text {
      font-size: 11px;
    }
  }

  .source {
    text-transform: uppercase;
    font-size: 11px;
  }
  /*
  .bar-area {
    position: relative;
    width: calc(100% - var(--right-space));
    background-color: var(--bg-light);
    border-radius: 10px;
    height: var(--row-height);
  }

  .bar-chart {
    position: absolute;
    height: 10px;
    background-color: var(--red);
    right: 0;
    border-radius: 10px;
    height: var(--row-height);
  }

  .bar-text {
    position: relative;
    display: flex;
    justify-content: space-between;
  }

  .bar-name {
    padding-left: 15px;
    line-height: var(--row-height);
    font-weight: 700;
  }

  .bar-perc {
    padding-right: 15px;
    line-height: var(--row-height);
    font-weight: 700;
  }

  .number-area {
    width: var(--right-space);
    line-height: var(--row-height);
    text-align: left;
    padding-left: 15px;
  }
  */


`;
